/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues, parseDate, parseDateTime, serializeDate, serializeDateTime } from '../runtime';
import type { PalReauthReportGenerationState } from './PalReauthReportGenerationState';
import {
    PalReauthReportGenerationStateFromJSON,
    PalReauthReportGenerationStateFromJSONTyped,
    PalReauthReportGenerationStateToJSON,
    PalReauthReportGenerationStateToJSONTyped,
} from './PalReauthReportGenerationState';
import type { PalReauthReportGenerationTrigger } from './PalReauthReportGenerationTrigger';
import {
    PalReauthReportGenerationTriggerFromJSON,
    PalReauthReportGenerationTriggerFromJSONTyped,
    PalReauthReportGenerationTriggerToJSON,
    PalReauthReportGenerationTriggerToJSONTyped,
} from './PalReauthReportGenerationTrigger';

/**
 * 
 * @export
 * @interface PalReauthReportGeneration
 */
export interface PalReauthReportGeneration {
    /**
     * 
     */
    id: string;
    /**
     * 
     */
    state: PalReauthReportGenerationState;
    /**
     * 
     */
    trigger: PalReauthReportGenerationTrigger;
    /**
     * 
     */
    report_text?: string | null;
    /**
     * 
     */
    overridden_report_text?: string | null;
    /**
     * 
     */
    error_message?: string | null;
    /**
     * 
     */
    date_created: Date;
}



/**
 * Check if a given object implements the PalReauthReportGeneration interface.
 */
export function instanceOfPalReauthReportGeneration(value: object): value is PalReauthReportGeneration {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('state' in value) || value['state'] === undefined) return false;
    if (!('trigger' in value) || value['trigger'] === undefined) return false;
    if (!('date_created' in value) || value['date_created'] === undefined) return false;
    return true;
}

export function PalReauthReportGenerationFromJSON(json: any): PalReauthReportGeneration {
    return PalReauthReportGenerationFromJSONTyped(json, false);
}

export function PalReauthReportGenerationFromJSONTyped(json: any, ignoreDiscriminator: boolean): PalReauthReportGeneration {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'state': PalReauthReportGenerationStateFromJSON(json['state']),
        'trigger': PalReauthReportGenerationTriggerFromJSON(json['trigger']),
        'report_text': json['report_text'] === undefined ? undefined : json['report_text'] === null ? null : json['report_text'],
        'overridden_report_text': json['overridden_report_text'] === undefined ? undefined : json['overridden_report_text'] === null ? null : json['overridden_report_text'],
        'error_message': json['error_message'] === undefined ? undefined : json['error_message'] === null ? null : json['error_message'],
        'date_created': (json['date_created'] == null ? json['date_created'] : parseDateTime(json['date_created'])),
    };
}

export function PalReauthReportGenerationToJSON(json: any): PalReauthReportGeneration {
    return PalReauthReportGenerationToJSONTyped(json, false);
}

export function PalReauthReportGenerationToJSONTyped(value?: PalReauthReportGeneration | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'state': PalReauthReportGenerationStateToJSON(value['state']),
        'trigger': PalReauthReportGenerationTriggerToJSON(value['trigger']),
        'report_text': value['report_text'],
        'overridden_report_text': value['overridden_report_text'],
        'error_message': value['error_message'],
        'date_created': value['date_created'] == null ? value['date_created'] : serializeDateTime(value['date_created']),
    };
}

